import { translation, TranslatedComponent } from '@hh.ru/front-static-app';

import styles from './styles.less';

const TrlKeys = {
    match: {
        title: 'career-platform.page-cert-landing.section.advantages.match.title',
        description: 'career-platform.page-cert-landing.section.advantages.match.description',
    },
    confirm: {
        title: 'career-platform.page-cert-landing.section.advantages.confirm.title',
        description: 'career-platform.page-cert-landing.section.advantages.confirm.description',
    },
    mark: {
        title: 'career-platform.page-cert-landing.section.advantages.mark.title',
        description: 'career-platform.page-cert-landing.section.advantages.mark.description',
    },
};

const SectionAdvantages: TranslatedComponent = ({ trls }) => (
    <section className={styles.container}>
        <article className={styles.item}>
            <h3 className={styles.title}>{trls[TrlKeys.match.title]}</h3>
            <p className={styles.itemDescription}>{trls[TrlKeys.match.description]}</p>
        </article>
        <div className={styles.divider} />
        <article className={styles.item}>
            <h3 className={styles.title}>{trls[TrlKeys.confirm.title]}</h3>
            <p className={styles.itemDescription}>{trls[TrlKeys.confirm.description]}</p>
        </article>
        <div className={styles.divider} />
        <article className={styles.item}>
            <h3 className={styles.title}>{trls[TrlKeys.mark.title]}</h3>
            <p className={styles.itemDescription}>{trls[TrlKeys.mark.description]}</p>
        </article>
    </section>
);

export default translation(SectionAdvantages);
